import { SearchInput } from "PFApp/components/search_input";
import React from "react";

import { useSkillsManagementContext } from "../contexts/skills_management_context_provider";
import { SkillsManagementTableCounters } from "./skills_management_table_counters";
import css from "./skills_management_table_header.module.scss";

export const SkillsManagementTableHeader = () => {
  const { term, setTerm, setCurrentPage } = useSkillsManagementContext();

  return (
    <div className={css.tableHeader}>
      <SkillsManagementTableCounters />
      <SearchInput
        onTermChange={(term) => {
          setTerm(term);
          setCurrentPage(1);
        }}
        term={term}
        withSearchIcon={true}
        classes={{ root: css.search }}
      />
    </div>
  );
};
